import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { getContentHighlightedWords } from '@/utils/highlight';
import store from '@/store';

VeeValidate.Validator.extend('checkBannedWords', {
  validate: (value: any) => {
    const highlightedWords = getContentHighlightedWords(value, (store.state as any).settings.settings.bannedWords);
    const valid = !highlightedWords.length;

    return {
      valid,
      data: highlightedWords,
    };
  },
});

// Optional URL: valid when empty; when present must be a valid URL with protocol (http/https)
const urlPattern = /^https?:\/\/[\w.-]+\.[a-z]{2,}(?:\/[\w./?=%-]*)?$/i;
VeeValidate.Validator.extend('optional_url', {
  validate: (value: any) => {
    const str = value === undefined || value === null ? '' : String(value).trim();
    if (str === '') {
      return { valid: true };
    }
    return { valid: urlPattern.test(str) };
  },
});

Vue.use(VeeValidate, { inject: false, delay: 700 });

export default VeeValidate;
